'use client';
import { Label } from '@/components/client/Label/Label';

/* import React, { useRef, useCallback } from 'react';
import style from './OurServicesSection.module.scss';
import { Icons } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ServiceCard } from './components/ServiceCard/ServiceCard';
import {
  HeatingAndAirServiceIcon,
  BrokerageIcon,
  CounstructionIcon,
  ElectricalProblemIcon,
  PlumbingSolution,
  RemodelingIcon,
} from '@/public/icons/services/icons';
import 'swiper/css';
import Link from 'next/link'; */

/* const data = [
  {
    icon: HeatingAndAirServiceIcon,
    title: 'Heating and Air Services',
    description:
      'Whether you need custom HVAC solutions, system repairs, or new installations, our expert team is here to help.',
    path: '/services/heating-and-air',
  },
  {
    icon: ElectricalProblemIcon,
    title: 'Electrical Services',
    path: '/services/electrical',

    description:
      'From simple repairs to complete rewiring projects, our electrical solutions are designed to keep your home safe.',
  },
  {
    icon: PlumbingSolution,
    title: 'Plumbing',
    path: '/services/plumbing',

    description: `Don't let plumbing issues disrupt your daily routine. Our plumbing solutions cover everything from leaky faucets.`,
  },
  {
    icon: RemodelingIcon,
    title: 'Remodeling',
    path: '/services/remodeling',

    description:
      'Elevate your space with our expert remodeling. From kitchens to outdoor areas, we bring your vision to life.',
  },
  {
    icon: CounstructionIcon,
    title: 'New Construction',
    path: '/services/construction',

    description:
      'Build your dream home with our expert new construction services, ensuring quality every step of the way.',
  },
  {
    icon: BrokerageIcon,
    title: 'Real Estate Brokerage',
    path: '/services/brokerage',

    description:
      'Buy or sell with confidence using our expert real estate guidance for the best results.',
  },
]; */

export const OurServicesSection = () => {
  return (
    <section className="bg-cream py-16">
      <div className="mb-5 flex items-center justify-start">
        <Label label="Services" />
      </div>
      <div className="description-with-links mx-auto">
        <div className="mb-12 text-center">
          <h2 className="mb-6 text-3xl font-bold text-gray-900">
            Our{' '}
            <span
              style={{ color: '#fca12c' }}
              className="textOrange font-semibold"
            >
              Home & Business
            </span>{' '}
            Services
          </h2>
          <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700">
            Tytum is your trusted name for a full range of professional service
            solutions for residential and commercial properties. With us, you
            won’t need multiple contractors or service providers. We handle
            everything from essential repairs to large-scale projects under one
            roof. Do you want to refurbish a family house or enhance a
            commercial space? We’ll get you covered.
          </p>
        </div>

        <div className="mb-8 grid grid-cols-1 gap-6 md:grid-cols-2">
          <div className="rounded-lg bg-white p-6">
            <div className="flex items-start space-x-4">
              <div className="shrink-0">
                {/* <div className="flex size-12 items-center justify-center rounded-full bg-blue-500">
                  <span className="text-lg font-bold text-white">C</span>
                </div> */}
              </div>
              <div className="flex-1">
                <h3 className="mb-2 font-semibold text-gray-900">
                  <a href="https://tytum.com/services/heating-and-air">
                    Heating and Air
                  </a>
                </h3>
                <p className="text-sm leading-relaxed text-gray-600">
                  We provide end-to-end HVAC solutions, quick fixes, complex
                  repairs, and maintenance plans to ensure efficient indoor
                  climate control for your home or commercial space all year
                  round. We can also help you modernize your existing system to
                  reduce energy costs or upgrade it with equipment to improve
                  air quality.
                </p>
              </div>
            </div>
          </div>

          <div className="rounded-lg bg-white p-6">
            <div className="flex items-start space-x-4">
              <div className="flex-1">
                <h3 className="mb-2 font-semibold text-gray-900">
                  <a href="https://tytum.com/services/heating-and-air/ductless-ac-installation">
                    Ductless mini split AC installation
                  </a>
                </h3>
                <p className="text-sm leading-relaxed text-gray-600">
                  Do you want more climate control flexibility with room-by-room
                  temperature adjustments? Or do you seek to upgrade an HVAC
                  system in an older property without traditional ductwork? We
                  offer individual ductless mini split system solutions for
                  better comfort and quiet, energy-wise operation.
                </p>
              </div>
            </div>
          </div>

          <div className="rounded-lg bg-white p-6">
            <div className="flex items-start space-x-4">
              <div className="flex-1">
                <h3 className="mb-2 font-semibold text-gray-900">
                  <a href="https://tytum.com/services/electrical">Electrical</a>
                </h3>
                <p className="text-sm leading-relaxed text-gray-600">
                  Our licensed electricians are trained and equipped to handle a
                  variety of electrical tasks and jobs. They can set up new
                  wiring, perform whole-house rewiring, upgrade your lighting
                  system, develop new lighting design, and integrate smart
                  lighting solutions. They can even conduct electrical safety
                  checks to ensure compliance with industry standards.
                </p>
              </div>
            </div>
          </div>

          <div className="rounded-lg bg-white p-6">
            <div className="flex items-start space-x-4">
              <div className="flex-1">
                <h3 className="mb-2 font-semibold text-gray-900">
                  <a href="https://tytum.com/services/plumbing">Plumbing</a>
                </h3>
                <p className="text-sm leading-relaxed text-gray-600">
                  Our plumbing services are designed to take the strain out of
                  any plumbing issue you may have. From emergency repairs to
                  eliminate drips and leaks, or replace outdated fixtures, to
                  water heater services, major sewage repairs, water filtration
                  installations, and even gas line services, we can maintain
                  your plumbing systems to keep them functional and in good
                  condition.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          <div className="rounded-lg bg-white p-4">
            <div className="text-center">
              <h3 className="mb-2  font-semibold text-gray-900">
                <a href="https://tytum.com/services/remodeling">Remodeling</a>
              </h3>
              <p className="text-sm leading-relaxed text-gray-600">
                Are you about to transform your home or office, or do you need
                to renew a single room? We have a team of experienced remodelers
                who can make renovations with precision. They can help you with
                a full-house transformation, refurbish your kitchen or bathroom,
                or revamp your outdoor space using professional skill, modern
                technology, and quality materials.
              </p>
            </div>
          </div>

          <div className="rounded-lg bg-white p-4">
            <div className="text-center">
              <h3 className="mb-2  font-semibold text-gray-900">
                <a href="https://tytum.com/services/construction">
                  New Construction
                </a>
              </h3>
              <p className="text-sm leading-relaxed text-gray-600">
                Building from the ground up is an extremely challenging task
                unless you have professionals on your side. Want to add a garage
                or another storey to your property? Or plan to build a custom
                house from scratch? Our seasoned specialists can coordinate
                every step of your construction project from start to finish,
                ensuring quality and timely results.
              </p>
            </div>
          </div>

          <div className="rounded-lg bg-white p-4">
            <div className="text-center">
              <h3 className="mb-2  font-semibold text-gray-900">
                <a href="https://tytum.com/services/brokerage">
                  Real Estate Brokerage
                </a>
              </h3>
              <p className="text-sm leading-relaxed text-gray-600">
                We are more than just contractors, we can support your real
                estate goals as well. We have in-depth market knowledge and
                hands-on expertise to help you buy, sell, and invest in property
                with confidence.
              </p>
            </div>
          </div>

          {/* <div className="rounded-lg bg-white p-4">
            <div className="text-center">
              <h4 className="mb-2 text-sm font-semibold text-gray-900">
                Energy-Efficiency Audits
              </h4>
              <p className="leading-relaxed text-gray-600">
                We give you a clear picture of your current system’s
                performance, identifying areas where you&apos;re losing money
                and comfort. We&apos;ll offer complete system upgrades,
                replacing outdated equipment with high-efficiency models.
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
  /* const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  return (
    <div className={'w-full'}>
      {' '}
      <div>
        <div className="mb-5 flex items-center justify-start">
          <Label label="Our Services" />
        </div>
        <div className="mb-10 flex w-full flex-col items-center justify-between md:flex-row">
          <h2 className="mb-8 w-full text-4xl font-bold">
            <p className="text-start">
              <span className="text-textOrange font-semibold">
                The Best Service.
              </span>
            </p>
            <p className="text-start">
              <span className="text-textBlack font-semibold">
                The Best Quality.
              </span>
            </p>
          </h2>

          <div className="mt-4 flex w-full items-center justify-center md:mt-0 md:justify-end">
            <div className={style.controls}>
              <Button
                aria-label="previous"
                onClick={handlePrev}
                className="mr-2 rounded-full border border-black bg-white px-5 py-2 text-lg text-black"
              >
                <Icons.arrowLeft />
              </Button>
              <Button
                aria-label="next"
                onClick={handleNext}
                className="rounded-full bg-black px-5 py-2 text-lg text-white"
              >
                <Icons.arrowRight />
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Swiper
        ref={sliderRef}
        slidesPerView={1}
        spaceBetween={24}
        navigation={true}
        effect="fade"
        loop={true}
        // autoplay={true}
        modules={[Autoplay, Navigation]}
        className="testimonals-swiper"
        breakpoints={{
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: 4,
          },
        }}
      >
        {data.map((item, idx) => (
          <SwiperSlide key={idx}>
            <ServiceCard isBlackBg={idx % 2 === 0} {...item} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="flex justify-center pt-20">
        {' '}
        <Link
          href="/company/about"
          className="  mb-16 flex w-fit items-start  gap-2 rounded-full border border-black bg-white px-3 py-2 text-start text-base text-black hover:bg-gray-200"
        >
          <span className="text-base">More About Us</span>{' '}
          <span>{<Icons.info />}</span>
        </Link>
      </div>
    </div>
  ); */
};
